import create from "zustand";
import { devtools } from "zustand/middleware";

const store = (set) => ({
  query: { type: null, token: null },
  setQuery: (query) => set((state) => ({ query: query })),
  resultVisible: false,
  setResultVisible: (visible) => set((state) => ({ resultVisible: visible })),
  alertMsg: "",
  setAlertMsg: (val) => set((state) => ({ alertMsg: val })),
  role1: 0,
  setRole1: (role) => set((state) => ({ role1: role })),
  role2: 0,
  setRole2: (role) => set((state) => ({ role2: role })),
  role3: 0,
  setRole3: (role) => set((state) => ({ role3: role })),
  members: [],
  setMembers: (data) => set((state) => ({ members: data })),
});
export const useStore = create(devtools(store));
